import { useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { EffectCards } from 'swiper/modules';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import { hexToRgb } from '../../common/hexToRgb';
import { updateColor } from '../../js/colorHandling';

export function Color({ colors }) {
  const slides = colors;
  const [swiperRef, setSwiperRef] = useState(null);
  const [isChange, setIsChange] = useState(false);
  const lassThan390px = useMediaQuery('(max-width:390px)');

  return (
    <div style={{ height: '100%' }}>
      <SwiperComponent
        slidesPerView={lassThan390px ? 6 : 7}
        ref={swiperRef}
        initialSlide={slides.length / 2}
        onSwiper={(swiper) => {
          setIsChange(false);
          setSwiperRef(swiper);
        }}
        onActiveIndexChange={(swiper) => {
          updateColor(hexToRgb(slides[swiper.realIndex]));
          if (isChange) {
            const temp = hexToRgb(slides[swiper.realIndex]);
            updateColor(temp);
          }
          setIsChange(true);
        }}
        centeredSlides={true}
        loop
        effect={'cards'}
        cardsEffect={{
          perSlideOffset: 70,
          slideShadows: false,
          perSlideRotate: 4,
          rotate: 10,
        }}
        modules={[EffectCards]}
        className="colorSwiper"
        style={{ height: '100%' }}
      >
        {slides?.map((item, index) => (
          <SwiperSlide key={index}>
            <div
              style={{
                background:
                  'rgba(' +
                  item?.rgba[0] +
                  ',' +
                  item?.rgba[1] +
                  ',' +
                  item?.rgba[2] +
                  ',' +
                  item?.rgba[3] +
                  ')',
                margin: 'auto',
              }}
              className="colorItem"
            ></div>
          </SwiperSlide>
        ))}
      </SwiperComponent>
    </div>
  );
}
